import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PageState } from "@/components/common/PageState";
import { GeneralInfoForm } from "@/components/pages/general-info/components/GeneralInfoForm";
import { useHotel } from "@/hooks/useHotel";
import { Role } from "@/types/user";

export const GeneralInfoPage = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { hotel, isLoading } = useHotel();

  const managers = useMemo(
    () =>
      hotel?.employees?.filter(
        (employee) => employee.role === Role.HOTEL_ADMIN,
      ) ?? [],
    [hotel?.employees],
  );

  if (isLoading) {
    return <PageState text={t("common.loading")} />;
  }

  if (!hotel) {
    return <PageState text={t("billing.hotelNotSelected")} tone="error" />;
  }

  return <GeneralInfoForm hotel={hotel} managers={managers} />;
};
